import React from "react";

import Divider from "@busbud/design-system-components/dist/Divider";
import Heading from "@busbud/design-system-components/dist/Heading";
import IconButton from "@busbud/design-system-components/dist/IconButton";
import CrossSM from "@busbud/design-system-components/dist/Icons/Cross/SM";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./cart-itinerary.styles";
import { Itinerary } from "../../itinerary";

interface Props {
  direction: "outbound" | "return";
  departure_id: string;
  onClose: () => void;
}

export const CartItinerary: React.FC<Props> = ({
  onClose,
  departure_id,
  direction
}) => {
  const { classes } = useStyles();
  const { translator } = useAppContext();

  return (
    <>
      <Stack
        justifyContent="space-between"
        alignItems="center"
        className={classes.header}
      >
        <Heading size="sm">
          {translator.t("!departure.stops-and-transfers.title")}
        </Heading>
        <IconButton
          onClick={onClose}
          color="secondary"
          variant="text"
          size="xs"
        >
          <CrossSM color="icon.primary.opaque" />
        </IconButton>
      </Stack>
      <Divider />
      <div className={classes.content}>
        <Itinerary trip_id={departure_id} direction={direction} />
      </div>
    </>
  );
};
